module.exports = __webpack_public_path__ + "media/images/features/modification/eyecatch-point-2-82c4daa34774809fa315da025f4daf33.svg";